<template>
  <div class="animated fadeIn">
    <b-row class="dashboard-filter-row">
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <div v-if="!filteredResults">
              <h4 class="mb-0">{{ peopleinsystem ? peopleinsystem.toLocaleString() : 0 }}</h4>
              <p>Person Records</p>
            </div>
            <div v-if="filteredResults">
              <h4 class="mb-0">{{personTotalCount}} of {{ peopleinsystem ? peopleinsystem.toLocaleString() : 0 }}</h4>
              <p>Person Records</p>
            </div>
            <b-button variant="primary" @click="addPerson">Add New Person</b-button>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By Name, Nickname, or Case Number</p>
            <b-input-group>
              <b-form-input v-model="filter" @input="handleFilterChange" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter" @click="clearFilter">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <div class="dashboard-filter-row--flex">
      <dashboard-filters @set-filter="onSetFilter" @clear-filter="onClearFilter"></dashboard-filters>
      <router-link :to="{ 'path': '/reviewannualdata/' + reviewYear, 'query': $route.query }">
        <b-button v-if="shouldShowAnnualDataReviewBtn" type="button" variant="warning" size="md">
          <span class="button-text dashboard-button-text">Review Annual Data</span>
        </b-button>
      </router-link>
    </div>
    <br>

    <b-row>
      <b-col sm="12">
        <b-card>
          <!--<h2 v-show="!finishedLoading" class="u-padding-bottom-20">Loading, please wait ...</h2>
          <pulse-loader :loading="!finishedLoading" :color="spinnerColor" :size="spinnerSize"></pulse-loader> -->
          <b-table
              v-show="finishedLoading"
              :sort-compare="sortDate"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :hover="true"
              :striped="true"
              :bordered="false"
              :small="true"
              :fixed="true"
              responsive="sm"
              :items="persons"
              :fields="tableFields"
              :current-page="currentPage">
              <div slot="id" class="" slot-scope="item">
                <b-link :class="{ 'link--inactive': item.item.inactive }" @click="goPerson(item.value)">
                  <span>
                    {{item.value}}
                  </span>
                  <span v-if="isShared(item)">
                    <img src='/static/img/shareYes.png' height="21" width="21">
                  </span>
              </b-link>
              </div>
              <!-- <div slot="ls_conclusion" slot-scope="item">
                <span>
                  {{ LABOR_CONCLUSION_LABEL_MAP[item.value] }}
                </span>
              </div> -->
              <!-- <div slot="b_confirmed" class="" slot-scope="item">
                <span class="">{{item.value === 'Confirmed' ? 'Confirmed' : item.value === 'Suspected' ? 'Suspected' : ''}}</span>
              </div> -->
          </b-table>
          <b-pagination
            :total-rows="personTotalCount"
            :per-page="NUM_OF_RECORDS_PER_PAGE"
            prev-text="Prev"
            next-text="Next"
            :current-page="currentPage"
            v-model="currentPage"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-if="userEUACheck()"
      ref="tosModal"
      centered id="myModal"
      title="Please Accept the End User Agreement Before Proceeding"
      size="lg"
      ok-title="I Accept the End User Agreement"
      cancel-title="I Do Not Accept the End User Agreement"
      @cancel="handleCancel"
      @ok="handleAcceptEUA"
      class="tos-modal"
      hide-header-close
      no-close-on-backdrop
    >
      <Tos :userId="$auth.user().id" />
    </b-modal>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

import MainChart from './charts/MainChart'
import cTable from './tables/Table'
import moment from 'moment'
import pie from './charts/PieChart'
import dashboardFilters from './t1/DashboardFilters'
import Tos from './t1/Admin/Tos.vue'
import { LABOR_CONCLUSION_LABEL_MAP, NUM_OF_RECORDS_PER_PAGE } from '@/helpers/enums'
import userStateMixin from '@/mixins/userState.js'
import userPermissionMixin from '@/mixins/userPermission.js'
import annualDataMixin from '@/mixins/annualData.js'

function formatBirthDateFormat (value) {
  if (value === '0000-00-00 00:00:00' || !value) {
    return ''
  }

  var date = moment(value).format('MM/DD/YYYY')
  return date
}

function uppercaseName (value) {
  if (_.isString(value)) {
    var str = value.toLowerCase()
      .split(' ')
      .map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1))
      })
    return str.join(' ')
  }
  return ''
}

export default {
  name: 'dashboard',
  components: {
    MainChart,
    cTable,
    pie,
    dashboardFilters,
    Tos
  },
  mixins: [userStateMixin, userPermissionMixin, annualDataMixin],
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      persons: 'getAllDashboardSearchPersons',
      peopleinsystem: 'getPersonRecordCount',
      personTotalCount: 'getPersonTotalCount',
      finishedLoading: 'getAllDashboardSearchPersonsResponse',
      sharePersonRecords: 'sharePersonRecords',
      isAnnualDataConfirmed: 'getIsAnnualDataConfirmed'
    }),

    tableFields () {
      return this.getTableFields()
    },

    shouldShowAnnualDataReviewBtn () {
      return this.isOrgManagerOrAdmin && this.isUserInLA && this.isWithinAnnualDataReviewWindow && !this.isAnnualDataConfirmed
    }
  },
  watch: {
    userCurrentContext (newValue) {
      if (newValue) {
        this.debouncedSearchPersons(true)
        this.getIsAnnualDataConfirmed()
      }
    },

    currentPage (newValue) {
      if (newValue) {
        this.debouncedSearchPersons()
      }
    },

    filter () {
      this.debouncedSearchPersons()
    }
  },
  data: function () {
    return {
      LABOR_CONCLUSION_LABEL_MAP,
      NUM_OF_RECORDS_PER_PAGE,
      spinnerColor: '#489AAC',
      spinnerSize: '50px',
      modalInfo: { title: '', content: '' },
      selected: 'Month',
      currentPage: 1,
      filter: sessionStorage.getItem('personSearchFilter') || '',
      showDataTable: false,
      filteredResults: false,

      // Fields for the Data Table
      supportBackup: true,
      supportNested: true,
      query: { limit: 10 },
      data: [],
      total: 0,
      Pagination: true,
      params: this.getInitParams(),

      // Fields for the bootstrap table
      sortBy: 'createdAt',
      sortDesc: true,
      sortDirection: 'desc',
      sortDate: function (a, b, key) {
        if (key === 'b_birthdate' || key === 'createdAt') {
          if (moment(a[key]).isValid() && moment(b[key]).isValid()) {
            return moment.utc(a[key]).diff(moment.utc(b[key]))
          } else if (!moment(a[key]).isValid() && !moment(b[key]).isValid()) {
            return 0
          } else if (moment(a[key]).isValid()) {
            return 1
          } else if (moment(b[key]).isValid()) {
            return -1
          }
        }
      }
    }
  },
  created: function () {
    this.debouncedSearchPersons = debounce(this.searchPersons.bind(this), 500)
    this.searchPersons(true)
    this.$store.dispatch('getSharePersonRecords')
    this.getIsAnnualDataConfirmed()
  },
  mounted: function () {
    // if (this.$auth.user()) {
    //   this.$store.commit('updateAuthUserInfo', {
    //     isCseitTrained: this.$auth.user().isCseitTrained,
    //     userInLA: this.$auth.user().primaryOrganization.mailingStateAbbreviation === 'LA',
    //     userInTX: this.$auth.user().primaryOrganization.mailingStateAbbreviation === 'TX'
    //   })
    // }
    this.showModal()
  },
  beforeDestroy () {
    this.$store.commit('RESET_SHARE_PERSON_RECORDS')
  },
  methods: {
    getInitParams () {
      return {
        filters: {
          populate: 'organization',
          sort: 'createdAt DESC'
        }
      }
    },

    onClearFilter () {
      this.params = this.getInitParams()
      this.filteredResults = false
      this.debouncedSearchPersons(false)
    },

    onSetFilter (filter) {
      this.params = filter
      this.filteredResults = true
      this.debouncedSearchPersons(false)
    },

    getIsAnnualDataConfirmed () {
      if (this.isUserInLA) {
        this.$store.dispatch('getIsAnnualDataConfirmed', {
          year: this.reviewYear
        })
      }
    },

    isShared (item) {
      const personId = _.get(item, 'item.id')
      const groupId = _.get(this.userCurrentContext, 'group.id')
      const records = this.sharePersonRecords
        .filter((sp) => _.get(sp, 'sperson.id') === personId &&
          (groupId ? _.get(sp, 'sgroup.id') === groupId : true)
        )

      return records.length
    },

    getTableFields () {
      const tableFields = [
        {
          key: 'id',
          label: 'Case',
          class: '',
          sortable: true
        },
        {
          key: 'b_last_name',
          label: 'Last Name',
          sortable: true,
          formatter: uppercaseName
        },
        {
          key: 'b_nickname',
          label: 'Nickname',
          sortable: true,
          formatter: uppercaseName
        },
        {
          key: 'b_birthdate',
          label: 'Birthdate',
          sortable: true,
          formatter: formatBirthDateFormat
        },
        {
          key: 'createdAt',
          label: 'Date Added',
          sortable: true,
          formatter: this.$utils.unixToHumanMS
        },
        {
          key: 'cseit_conclusion',
          label: 'CSE-IT',
          sortable: true
        },
        {
          key: 'b_confirmed',
          label: 'Victim Status',
          sortable: true
        },
        {
          key: 'organizationOwner',
          label: 'Owning Organization',
          sortable: true,
          formatter: function (value) {
            if (value) {
              return value.title
            }
          }
        }
      ]

      if (!this.isUserInLA) {
        return tableFields
      }

      tableFields.splice(6, 0, {
        key: 'ls_conclusion',
        label: 'Labor Screening',
        sortable: true,
        formatter: function (value) {
            if (value === '2') {
              return 'Level 2'
            } else if (value === '1') {
              return 'Level 1'
            } else if (value === '0') {
              return 'Not Enough Information'
            }
              return value
          }
      })
      return tableFields
    },
    searchPersons (shouldGetPersonRecordCount) {
      this.params.filters.searchString = this.filter.toLowerCase()
      this.params.filters.currentPage = this.currentPage
      if (shouldGetPersonRecordCount) {
        this.$store.dispatch('getPersonRecordCount', this.params)
      }
      this.$store.dispatch('getAllDashboardSearchPersons', this.params)
    },
    searchFilter (originalRecord) {
      let foundMatch = false
      const stringSearches = [ 'id', 'b_first_name', 'b_last_name', 'b_nickname', 'p_street_name', 'organization', 'externalId' ]

      if (this.filter === null) {
        return true
      }

      let filter = this.filter.toLowerCase()

      _.forEach(stringSearches, element => {
        let field = originalRecord[element]

        if (_.isString(field) && field !== '') {
          field = field.toLowerCase()
          if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
            foundMatch = true
          }
        }
      })

      // Eject before date check
      if (foundMatch) {
        return foundMatch
      }

      // Date checking
      // Lodash recommends using window.isFinite to determine if it's number-like... weird.
      const dateFields = [ 'b_birthdate', 'createdAt' ]
      if (window.isFinite(filter[0])) {
        let matchingDateString = false

        _.forEach(dateFields, (field) => {
          let formattedTimestamp
          let dateString = originalRecord[field]

          if (dateString !== '0000-00-00 00:00:00') {
            formattedTimestamp = this.$utils.formatDate(originalRecord[field])

            if (formattedTimestamp.indexOf(filter) >= 0) {
              matchingDateString = true
            }
          }
        })

        if (matchingDateString) {
          return true
        }
      }

      return foundMatch
    },
    goPerson (item) {
      if (item) {
        const path = '/person/' + item
        this.$router.push({ path: path })
      }
    },
    // presentVictimStatus (item) {
    //   let result = false
    //   if (item === 'Confirmed') {
    //     result = true
    //   } else {
    //     result = 'Suspected'
    //   }
    //   return result
    // },
    addPerson (item) {
      this.$router.push({ path: '/person/add' })
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    getRowCount (items) {
      return items.length
    },
    showModal () {
      if (this.$refs.tosModal) {
        this.$refs.tosModal.show()
      }
    },
    hideModal () {
      if (this.$refs.tosModal) {
        this.$refs.tosModal.hide()
      }
    },
    handleCancel (e) {
      e.preventDefault()
      alert('You must accept the End User Agreement in order to proceed. Contact lighthouse@alliesagainstslavery.org if you have any questions.')
    },
    handleAcceptEUA (e) {
      const user = this.$auth.user()
      const userId = user.id

      this.$store.dispatch('userAcceptedEUA', { id: userId })
    },
    userEUACheck () {
      const user = this.$auth.user()
      if (user.acceptedEUA > 0) {
        return false
      }
      return true
    },
    handleFilterChange (value) {
      sessionStorage.setItem('personSearchFilter', value)
    },
    clearFilter (value) {
      this.filter = ''
      sessionStorage.setItem('personSearchFilter', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.tos-modal .modal-body {
  padding: 1rem 2rem;
  line-height: 23px;
}

.tos-modal li {
  margin-bottom: 10px;
}

.tos-modal li ol {
  margin-top: 10px;
  list-style-type: lower-alpha;
}

.tos-modal ol li em {
  font-weight: bold;
  text-decoration: underline;
  font-style: normal;
}

.dashboard-filter-row {
	margin-bottom: 40px;

  &--flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;

    .row {
      flex: 1;
    }
  }
}

.dashboard-button-text {
  color: #ffffff;
}

.bg-info{
	height: 100%;
}

a {
  &.link--inactive {
    color: grey;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue